<script setup lang="ts">
import { computed } from 'vue'
import { FilterIcon } from 'Common/components/elements/icons/Icons'
import { useFilterStore } from 'Store/filterStore'
import { showFilters } from '@/featureFlags'

interface PropTypes {
  isFiltersVisible: boolean
  toggleIsFiltersVisible: () => void
}

const props = defineProps<PropTypes>()
const filterStore = useFilterStore()

const handleFilterButtonClick = () => {
  props.toggleIsFiltersVisible()
}

const filterButtonClass = computed(() => {
  if (props.isFiltersVisible === true) return 'filter-on'
  return ''
})
</script>

<template>
  <div v-if="showFilters" class="mr-4">
    <el-badge :value="filterStore.appliedFilterCount !== 0 ? filterStore.appliedFilterCount : undefined">
      <el-button text class="filter-button" :class="filterButtonClass" @click="handleFilterButtonClick">
        <FilterIcon />
      </el-button>
    </el-badge>
  </div>
</template>
